module.exports = __webpack_public_path__ + "img/d5.b1d4b4a3.jpg";